<!-- User form -->
@if (model().currentView === views.USER_FORM) {
  <h4 class="portal-text" style="color: black">
    {{ "GAST-PORTAL-NG.FORGET-PASSWORD-COMPONENT.PASSWORD_HELP" | translate }}
  </h4>
  <br />
  <form [formGroup]="userForm" (ngSubmit)="onUserFormSubmit(userForm.value)">
    <div class="form-group">
      <span>{{ "GAST-PORTAL-NG.FORGET-PASSWORD-COMPONENT.USERNAME_DESCRIPTION" | translate }}</span>
    </div>
    <div class="form-group">
      <label for="login">{{ "GAST-PORTAL-NG.FORGET-PASSWORD-COMPONENT.USERNAME" | translate }}</label>
      <input
        id="login"
        type="text"
        class="form-control"
        formControlName="login"
        aria-describedby="emailHelp"
        placeholder="{{ 'GAST-PORTAL-NG.FORGET-PASSWORD-COMPONENT.USERNAME' | translate }}"
        required
        [class.is-valid]="login.value !== '' && login.get('touched') && login.valid"
        [class.is-invalid]="login.get('touched') && login.invalid" />
      @if (login.invalid && (login.dirty || login.get("touched")) && login.errors?.["touched"]) {
        <div class="invalid-feedback">
          {{ "GAST-PORTAL-NG.FORGET-PASSWORD-COMPONENT.USERNAME_IS_REQUIRED" | translate }}
        </div>
      }
      @if (model().badUsername) {
        <small style="color: #dc3545; font-size: 80%; margin-top: 0.25rem; display: block">{{
          "GAST-PORTAL-NG.FORGET-PASSWORD-COMPONENT.BAD_USERNAME" | translate
        }}</small>
      }
      <br />
      <div class="row">
        <div class="col-6">
          <ng-content select="[button-login-view]"></ng-content>
        </div>
        <div class="col-6 text-right d-flex justify-content-end">
          <button
            type="submit"
            class="btn btn-primary"
            [style.background-color]="style().buttonBackgroundColor"
            [style.color]="style().buttonTextColor"
            [disabled]="!userForm.valid">
            {{ "GAST-PORTAL-NG.FORGET-PASSWORD-COMPONENT.CONTINUE" | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
  <!-- End of user form -->
}

<!-- Code form -->
@if (model().currentView === views.CODE_FORM) {
  <h4 style="color: black">{{ "GAST-PORTAL-NG.FORGET-PASSWORD-COMPONENT.CONFIRM_IDENTITY" | translate }}</h4>
  <br />
  <form [formGroup]="codeForm" (ngSubmit)="onCodeFormSubmit(codeForm.value)">
    <div class="form-group">
      <span
        >{{ "GAST-PORTAL-NG.FORGET-PASSWORD-COMPONENT.CODE_DESCRIPTION1" | translate }}{{ this.model().email
        }}{{ "GAST-PORTAL-NG.FORGET-PASSWORD-COMPONENT.CODE_DESCRIPTION2" | translate }}</span
      >
    </div>
    <div class="form-group">
      <label for="code">{{ "GAST-PORTAL-NG.FORGET-PASSWORD-COMPONENT.CODE" | translate }}</label>
      <input
        id="code"
        type="text"
        class="form-control"
        formControlName="code"
        aria-describedby="emailHelp"
        placeholder="{{ 'GAST-PORTAL-NG.FORGET-PASSWORD-COMPONENT.CODE' | translate }}"
        required
        [class.is-valid]="code.value !== '' && code.get('touched') && code.valid"
        [class.is-invalid]="code.get('touched') && code.invalid" />
      @if (code.invalid && (code.dirty || code.get("touched")) && code.errors?.["touched"]) {
        <div>
          {{ "GAST-PORTAL-NG.FORGET-PASSWORD-COMPONENT.CODE_IS_REQUIRED" | translate }}
        </div>
      }

      @if (model().badCode) {
        <small style="color: #dc3545; font-size: 80%; margin-top: 0.25rem; display: block">{{
          "GAST-PORTAL-NG.FORGET-PASSWORD-COMPONENT.CODE_NOT_MATCHED" | translate
        }}</small>
      }

      <br />
      <div class="row">
        <div class="col-6">
          <ng-content select="[button-code-view]"></ng-content>
        </div>
        <div class="col-6 text-right d-flex justify-content-end">
          <button
            type="submit"
            class="btn btn-primary"
            [style.background-color]="style().buttonBackgroundColor"
            [style.color]="style().buttonTextColor"
            [disabled]="!codeForm.valid">
            {{ "GAST-PORTAL-NG.FORGET-PASSWORD-COMPONENT.CONTINUE" | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
  <!-- End of code form -->
}

<!-- New password form -->
@if (model().currentView === views.PASSWORD_FORM) {
  <h4 style="color: black">{{ "GAST-PORTAL-NG.FORGET-PASSWORD-COMPONENT.ENTER_NEW_PASSWORD" | translate }}</h4>
  <br />
  <form [formGroup]="passwordForm" (ngSubmit)="onPasswordFormSubmit($any(passwordForm.value))">
    <div class="form-group">
      <label for="password">{{ "GAST-PORTAL-NG.FORGET-PASSWORD-COMPONENT.PASSWORD_DESCRIPTION" | translate }}</label>
      <input
        id="password"
        type="password"
        class="form-control"
        placeholder="{{ 'GAST-PORTAL-NG.FORGET-PASSWORD-COMPONENT.PASSWORD' | translate }}"
        formControlName="password"
        required
        [class.is-valid]="password.value !== '' && password.get('touched') && password.valid"
        [class.is-invalid]="password.get('touched') && password.invalid" />

      @if (password.invalid && (password.dirty || password.get("touched")) && password.errors?.["touched"]) {
        <div class="invalid-feedback">
          {{ "GAST-PORTAL-NG.FORGET-PASSWORD-COMPONENT.PASSWORD_IS_REQUIRED" | translate }}
        </div>
      }
    </div>
    <div class="form-group">
      <label for="passwordConfirmation">{{
        "GAST-PORTAL-NG.FORGET-PASSWORD-COMPONENT.PASSWORD_CONFIRMATION_DESCRIPTION" | translate
      }}</label>
      <input
        id="passwordConfirmation"
        type="password"
        class="form-control"
        placeholder="{{ 'GAST-PORTAL-NG.FORGET-PASSWORD-COMPONENT.PASSWORD_CONFIRMATION' | translate }}"
        formControlName="passwordConfirmation"
        required
        [class.is-valid]="passwordConfirmation.value !== '' && passwordConfirmation.dirty && passwordForm.valid"
        [class.is-invalid]="passwordConfirmation.dirty && (passwordConfirmation.invalid || passwordForm.invalid)" />
      <div class="valid-feedback">
        {{ "GAST-PORTAL-NG.FORGET-PASSWORD-COMPONENT.PASSWORDS_MATCHED" | translate }}
      </div>
      @if (passwordConfirmation.dirty) {
        <div class="invalid-feedback">
          @if (passwordForm.invalid) {
            {{ "GAST-PORTAL-NG.FORGET-PASSWORD-COMPONENT.PASSWORDS_NOT_MATCHED" | translate }}
          }
        </div>
      }
      <br />
      <div class="row">
        <div class="col-6">
          <ng-content select="[button-new-password-view]"></ng-content>
        </div>
        <div class="col-6 text-right d-flex justify-content-end">
          <button
            type="submit"
            class="btn btn-primary"
            [style.background-color]="style().buttonBackgroundColor"
            [style.color]="style().buttonTextColor"
            [disabled]="!passwordForm.valid">
            {{ "GAST-PORTAL-NG.FORGET-PASSWORD-COMPONENT.SAVE_CHANGES" | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
  <!-- End of new password form -->
}

<!-- Confirmation view -->

@if (model().currentView === views.PASSWORD_CHANGED) {
  <h4 style="color: black">{{ "GAST-PORTAL-NG.FORGET-PASSWORD-COMPONENT.PASSWORD_HELP" | translate }}</h4>
  <br />
  <p style="color: green"><br />{{ "GAST-PORTAL-NG.FORGET-PASSWORD-COMPONENT.PASSWORD_CHANGED" | translate }}</p>
  <div class="row">
    <div class="col-6">
      <ng-content select="[button-confirmation-view]"></ng-content>
    </div>
  </div>
}
<!-- End of conformation view -->
